
    <mat-toolbar class="toolbar">
      <mat-toolbar-row style="height: 48px">
        <span fxShow.md="true" fxHide>{{ title | translate | titlecase }}</span>
        <span class="fill"></span>
        <div class="username">{{ user.name }}</div>
        <button
          *ngIf="connection"
          mat-icon-button
          (click)="openNotifications.emit()"
        >
          <mat-icon svgIcon="notifications" class="toolbar__notifications_icon">
            <span
              [hidden]="!unreadNotifications"
              class="toolbar__notifications_icon--circle"
            ></span>
          </mat-icon>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="accountMenu">
          <mat-icon svgIcon="account_circle"> </mat-icon>
        </button>
        <flag-icon
          style="padding-right: 8px"
          *ngIf="connection"
          (click)="onChangeLanguage('en')"
          class="flag"
          country="gb"
        ></flag-icon>
        <flag-icon
          *ngIf="connection"
          (click)="onChangeLanguage('de-LU')"
          class="flag"
          country="de"
        ></flag-icon>

        <mat-menu #accountMenu="matMenu">
          <button
            fxLayout="row"
            fxLayoutAlign="start center"
            mat-menu-item
            (click)="onLogOut()"
          >
            <mat-icon matPrefix svgIcon="exit_to_app"></mat-icon>
            {{ 'logout' | translate }}
          </button>

          <button
            fxShow
            fxHide.lg
            fxLayout="row"
            fxLayoutAlign="start center"
            mat-menu-item
            *ngFor="let option of sidenavOptions"
            (click)="onSelectSidenavOption(option)"
          >
            <mat-icon matPrefix [svgIcon]="option.icon"></mat-icon>
            {{ option.name | translate | titlecase }}
          </button>
        </mat-menu>
      </mat-toolbar-row>
    </mat-toolbar>
  